import React from "react";
import "./LoadingWheel.scss"

export default function LoadingSpinner({ status, percent }) {
  const showStatus = status != null && status !== "";
  const showPercent = percent != null && !Number.isNaN(percent);

  return (
    <div className="spinner-container">
      <div className="loading-spinner" />
      {(showStatus || showPercent) && (
        <div className="loading-status">
          {showStatus && <p className="loading-status__text">{status}</p>}
          {showPercent && (
            <p className="loading-status__percent">{Math.min(100, Math.max(0, Math.round(percent)))}%</p>
          )}
        </div>
      )}
    </div>
  );
}